import React from 'react'
import CashNoticeComponent from '../CashNoticeComponent'
import CashZoneComponent from '../CashZoneComponent'
import CashButton from '../CashButton'
import CashTab from '../CashTab'
import CashTableComponent from '../CashTableComponent'
import Cash2cashZoneComponent from '../Cash2cashZoneComponent'
const noticeList = [
    '※  1회 최소 환전금액: <span class="text-crimson">10,000원 </span> / 1회 최대 환전금액: <span class="text-crimson">무제한</span> ',
    '※ 재환전 대기시간은 없습니다. <span class="text-crimson"> 다만 짧은 시간에 환전을 계속 누르는 행위는 피해주시길 바랍니다. </span>',
    '※ 모든 환전은 순차적으로 진행되며 환전 대기 인원이 많을 경우 <span class="text-crimson"> 최대 30분 </span> 까지 소요될 수도 있습니다.',
    '※ 회원가입 시 기재된 <span class="text-crimson"> 본인 명의 계좌만 출금이 가능 </span> 합니다.',
  ]
const Cash2Component = () => {
  return (
    <>
     <div className="">
        <CashNoticeComponent  titleMobile="충전신청전 반드시 확인해 주세요." titleDesktop="환전방법"  notices={noticeList}/>
        <Cash2cashZoneComponent />
        <CashButton label="충전신청"/>
        <div className='hidden lg:block'>
          <CashTab />
          <CashTableComponent />
        </div>
      </div>
    </>
  )
}

export default Cash2Component